import React from 'react';
import { connect } from 'react-redux';

import BillingHeader from './BillingHeader';

function BillingError(props: { desktop: boolean; error?: string }) {
  return (
    <div>
      <BillingHeader desktop={props.desktop} page="error" />
      <div className="alert alert-danger card-row" role="alert" style={{ marginTop: '25px' }}>
        {props.error}
      </div>
      <br />
      <br />
      <a href="javascript:history.back()" style={{ margin: 'auto', display: 'block' }}>
        <button type="button" className="btn btn-info">
          Go Back
        </button>
      </a>
    </div>
  );
}

function mapStateToProps(state: any) {
  return {
    error: state.billing.error,
  };
}

export default connect(mapStateToProps, null)(BillingError);
